
import DeveloperAPIService from '@/modules/developer/services/apiService'

export default class DeveloperModule {
  constructor() {
  }

  install(Vue) {
     // Services
     Vue.prototype.$apiService.developerService = new DeveloperAPIService(Vue.prototype.$api, Vue.prototype.$reportingApi)
  }


  getRoutes() {
    return [
      {
        path: '/developer',
        name: 'developer',
        component: () => import('@/modules/developer/views/developer.vue'),
        meta: {
          requiresAuth: true,
          title: 'Developer',
          menuLink: '/developer',
          breadcrumbs: [
              { title: 'Home', link: '/'},
          ],
        }
      },
      {
        path: '/developer/accounts',
        name: 'developerAccountList',
        component: () => import('@/modules/developer/views/developerAccountList.vue'),
        meta: {
          requiresAuth: true,
          title: 'Developer Accounts',
          menuLink: '/developer/accounts',
          breadcrumbs: [
              { title: 'Home', link: '/'},
          ],
        }
      },
      {
        path: '/developer/accounts/:id',
        name: 'developerSystemAccount',
        component: () => import('@/modules/developer/views/developerAccount.vue'),
        meta: {
          requiresAuth: true,
          title: 'System Account',
          menuLink: '/developer',
          breadcrumbs: [
              { title: 'Home', link: '/'},
              { title: 'Developer Accounts', link: '/developer/accounts'},
          ],
        }
      },
      {
        path: '/developer/optimiser',
        name: 'developerOptimiser',
        component: () => import('@/modules/developer/views/developerOptimiser.vue'),
        meta: {
          requiresAuth: true,
          title: 'Developer - Optimiser',
          menuLink: '/developer',
          breadcrumbs: [
              { title: 'Home', link: '/'},
          ],
        }
      },
    ]
  }
}